import styled from 'styled-components'
import {layout} from 'styled-system'

const Img = styled.img`
  	${layout}
`

export default Img;